<div class="checkout-overlay" *ngIf="show" (click)="closeModal()">
  <div class="checkout-modal" (click)="$event.stopPropagation()">
    
    <!-- Floating Close Button -->
    <button class="close-button" (click)="closeModal()" aria-label="Close checkout">
      <i class="bx bx-x"></i>
    </button>

    <!-- Success Screen -->
    <div class="success-screen animate-fade-in" *ngIf="orderSuccess">
      <div class="success-icon-wrapper">
        <i class="bx bx-check-circle success-pulse-icon"></i>
      </div>
      <h2>Payment Successful!</h2>
      <p class="success-subtitle">Thank you for your order.</p>
      
      <div class="order-details-card">
        <div class="detail-row">
          <span class="detail-label">Order ID</span>
          <span class="detail-value font-mono">{{ placedOrderId }}</span>
        </div>
        <div class="detail-row" *ngIf="orderData">
          <span class="detail-label">Amount Paid</span>
          <span class="detail-value font-bold">${{ orderData.total }}</span>
        </div>
      </div>
      
      <button type="button" class="done-btn" (click)="closeModal()">
        Return to Shop
      </button>
    </div>

    <!-- Active Form (Hidden on Success) -->
    <ng-container *ngIf="!orderSuccess">
      
      <!-- Secure Checkout Header -->
      <div class="checkout-header">
        <div class="header-badge">
          <i class="bx bx-lock-alt"></i> Secure Checkout
        </div>
        <h3>Complete Your Order</h3>
        
        <!-- Summary Info -->
        <div class="order-quick-summary" *ngIf="orderData">
          <div class="summary-breakdown">
            <div class="summary-row">
              <span class="summary-label">Subtotal:</span>
              <span class="summary-value">${{ orderData.subtotal | number:'1.2-2' }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Tax:</span>
              <span class="summary-value">${{ orderData.tax | number:'1.2-2' }}</span>
            </div>
            <div class="summary-row total-row">
              <span class="summary-label total-label">Total to pay:</span>
              <span class="summary-value total-value">${{ orderData.total | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Error Alert Banner -->
      <div class="error-banner" *ngIf="errorMessage">
        <i class="bx bx-error-circle error-banner-icon"></i>
        <div class="error-banner-text">{{ errorMessage }}</div>
      </div>

      <form [formGroup]="form">
        
        <!-- Customer Details Section Title -->
        <div class="section-title">
          <span>1. Customer Details</span>
        </div>

        <!-- Name Input Group -->
        <div class="form-group">
          <label for="checkout-name">Full Name</label>
          <div class="input-wrapper" [class.input-invalid]="form.get('name')?.touched && form.get('name')?.invalid">
            <i class="bx bx-user field-icon"></i>
            <input id="checkout-name" formControlName="name" placeholder="John Doe" autocomplete="name">
          </div>
          <div class="validation-message" *ngIf="form.get('name')?.touched && form.get('name')?.invalid">
            Please enter a valid name (minimum 3 letters).
          </div>
        </div>

        <!-- Mobile Input Group -->
        <div class="form-group">
          <label for="checkout-mobile">Mobile Number</label>
          <div class="input-wrapper" [class.input-invalid]="form.get('mobile')?.touched && form.get('mobile')?.invalid">
            <i class="bx bx-phone field-icon"></i>
            <input id="checkout-mobile" formControlName="mobile" type="tel" placeholder="1234567890" maxlength="15" 
                   (input)="restrictToNumbers($event)" (keydown)="preventNonNumeric($event)" autocomplete="tel">
          </div>
          <div class="validation-message" *ngIf="form.get('mobile')?.touched && form.get('mobile')?.invalid">
            Mobile number is required.
          </div>
        </div>

        <!-- Email Input Group -->
        <div class="form-group">
          <label for="checkout-email">Email Address</label>
          <div class="input-wrapper" [class.input-invalid]="form.get('email')?.touched && form.get('email')?.invalid">
            <i class="bx bx-envelope field-icon"></i>
            <input id="checkout-email" formControlName="email" type="email" placeholder="john@example.com" autocomplete="email">
          </div>
          <div class="validation-message" *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
            Please enter a valid email address.
          </div>
        </div>

        <!-- Payment Details Section Title -->
        <div class="section-title mt-4">
          <span>2. Payment Details</span>
        </div>

        <!-- Stripe Container -->
        <div class="payment-section">
          <!-- Loading Skeleton -->
          <div class="skeleton-loader" *ngIf="isLoadingPaymentElement">
            <div class="skeleton-line title"></div>
            <div class="skeleton-line input"></div>
            <div class="skeleton-line help"></div>
          </div>
          
          <div id="payment-element" [class.hidden]="isLoadingPaymentElement"></div>
        </div>

        <!-- Confirm Button -->
        <button type="button" class="submit-btn" [disabled]="form.invalid || isProcessing || isLoadingPaymentElement" (click)="placeOrder()">
          <span *ngIf="!isProcessing">
            <i class="bx bx-credit-card icon-left"></i> Confirm Order ${{ orderData?.total| number:'1.2-2'}}
          </span>
          <span *ngIf="isProcessing" class="btn-spinner-content">
            <i class="bx bx-loader-alt bx-spin spinner-icon"></i> Processing Payment...
          </span>
        </button>
        
        <p class="security-footer">
          <i class="bx bx-shield-quarter"></i> Powered by Stripe. Your connection is encrypted.
        </p>

      </form>
    </ng-container>

  </div>
</div>
